export default __webpack_public_path__ + "static/media/bg-home-tab.dc2ac984.png";